<template>
  <div class="Melamine">
    <div class="title">Diethylene Glycol</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="ITEMS" label="Item" width="300">
        </el-table-column>
        <el-table-column prop="STANDARD" label="Unit">
        </el-table-column>
        <!-- <el-table-column prop="RESULTS" label="Index">
        </el-table-column> -->
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>230kg/drum, 18.4mt/20'FCL, or 23mt net flexitank.</p>
    </div>
    <div class="item-huanhang">
      <label>Applications:</label>
      <p>
        DEG is used as a cement grinding aid due to its excellentefficacy and
        economic advantage compared to other cement grinding aids. It is used as
        mold irelease agent and stabilizer in oil dispersions. It can be used as
        a solvent for dyes, resins and oils. It is a humectant for tobacco, ink
        and glue. It is also used in cosmetics, brake fluid and lubricants. Iis
        used a chemical intermediate in the production of a variety of polymers.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        {
          ITEMS: "Appearance",
          STANDARD: "Transparent Liquid withoutmechanical impurity",
          RESULTS: "Transparent Liquid withoutmechanical impurity",
        },
        {
          ITEMS: "Color(Pt-Co), Hazen",
          STANDARD: "<=15",
          RESULTS: "3",
        },
        {
          ITEMS: "Density(20°C),kg m3",
          STANDARD: "1115.5-1117.6",
          RESULTS: "1.1165",
        },
        {
          ITEMS: "Water Content,% (m m)",
          STANDARD: "<=0.1",
          RESULTS: "0.02",
        },
        {
          ITEMS: "Initial Boiling Point ℃",
          STANDARD: ">=242",
          RESULTS: "244.4",
        },
        {
          ITEMS: "Dry Point℃",
          STANDARD: "<=250",
          RESULTS: "246",
        },
        {
          ITEMS: "Purity%(m.m)",
          STANDARD: "",
          RESULTS: "99.94",
        },
        {
          ITEMS: "Ethylene Glycol% (m m)",
          STANDARD: "<=0.15",
          RESULTS: "0.013",
        },
        {
          ITEMS: "Triethylene Glycol% (m.m)",
          STANDARD: "<=0.40",
          RESULTS: "0.036",
        },
        {
          ITEMS: "Fe(as Fe2)%(m.m)",
          STANDARD: "<=0.0001",
          RESULTS: "<=0.00001",
        },
        {
          ITEMS: "Acidity (as acetic acid) ,% (m.m)",
          STANDARD: "<=0.01",
          RESULTS: "0.0007",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
